import { render, staticRenderFns } from "./form-tipo-aplicacao.vue?vue&type=template&id=7c57d289&"
import script from "./form-tipo-aplicacao.vue?vue&type=script&lang=js&"
export * from "./form-tipo-aplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports